import {
  OrderGetResponseType,
  OrderShippingRequestType,
} from "@sellar-io/api-v2/types";
import { getItemWeight } from "@sellar-io/common";
import dayjs from "dayjs";
import { useEffect, useEffectEvent } from "react";
import { useNavigate } from "react-router";
import { CREATE_CONSIGNMENT, ORDER_DETAILS } from "../../../constants/routes";
import { apiV2AssertError } from "../../../hooks/api/v2/apiV2Request";
import { useOrderCreateShipment } from "../../../hooks/api/v2/order/useOrderCreateShipment";
import { useCreateShipmentContext } from "../../../hooks/useCreateShipmentContext.shared";
import { useParamAsNumber } from "../../../hooks/useParamAsNumber";
import { OrderCreateConsignmentInformation } from "./OrderCreateConsignmentInformation";

export const OrderCreateConsignmentUps = ({
  order,
}: {
  order: OrderGetResponseType;
}) => {
  const navigate = useNavigate();
  const { boxes, setBoxes, setItems } = useCreateShipmentContext();
  const orderId = useParamAsNumber(CREATE_CONSIGNMENT, "orderId");
  const shippingMutation = useOrderCreateShipment(orderId);

  const populateItems = useEffectEvent(() => {
    const items = order.OrderItems;
    let formattedItems: Array<
      OrderGetResponseType["OrderItems"][number] & { itemId: number }
    > = [];
    let draughtItems: Array<{
      OrderItemIds: number[];
      weight: number;
      isUnboxed: boolean;
    }> = [];
    items.forEach((item) => {
      new Array(item.quantity).fill("").forEach((data, index) => {
        formattedItems.push({
          ...item,
          itemId: parseInt(`${item.id}${index}`),
        });

        if (
          item.Product.containerType?.toLowerCase().includes("keg") ||
          item.Product.containerType?.toLowerCase().includes("cask")
        ) {
          const itemWeight = getItemWeight(item.Product);
          if (itemWeight > 0)
            draughtItems.push({
              OrderItemIds: [parseInt(`${item.id}${index}`)],
              weight: itemWeight,
              isUnboxed: true,
            });
        }
      });
    });
    setItems(formattedItems);
    setBoxes(draughtItems);
  });

  useEffect(() => {
    populateItems();
  }, []);

  const shippingMutationError =
    apiV2AssertError(shippingMutation.error)?.response?.data.message ?? null;

  return (
    <>
      <OrderCreateConsignmentInformation
        order={order}
        error={shippingMutationError}
        isSubmitting={shippingMutation.isPending}
        onSubmit={(data) => {
          if (boxes.length) {
            const body: OrderShippingRequestType =
              order.fulfillmentType === "ups"
                ? {
                    boxes,
                    type: "ups",
                    isResidentialAddress: data.isResidentialAddress,
                  }
                : {
                    boxes,
                    type: "apc",
                    deliveryInstructions: data.deliveryInstructions,
                    collectionDate: dayjs(data.collectionDate).toDate(),
                    collectionInstructions: data.collectionInstructions,
                  };

            shippingMutation.mutate(body, {
              onSuccess: () =>
                navigate(
                  `${ORDER_DETAILS.href({ orderId })}?tab=All+orders&shippingSuccess=true`,
                ),
            });
          }
        }}
      />
    </>
  );
};
